import React from 'react'
import { Icon } from '@buderus-apps/components'

import styles from './styles.module.scss'

const {
  loadingIndicator,
  loadingIndicatorIsLoading
} = styles

type TProps = {
  isLoading?: boolean
}

const LoadingIndicator = ({isLoading}: TProps) => {
  return (
    <div className={`${loadingIndicator} ${isLoading && loadingIndicatorIsLoading}`}>
      <Icon.ArtificialIntelligence />
    </div>
  )
}

export default React.memo(LoadingIndicator)
